import { useEffect } from 'react';
import { gtagTrack } from '../helpers/Tracking/Analytics';

export const trackViewItem = (id, title) => {
  gtagTrack('view_item', {
    items: [
      {
        item_id: id,
        item_name: title
      }
    ]
  });
};

const useTrackViewItem = (id, title) => {
  useEffect(() => {
    trackViewItem(id, title);
  }, [id, title]);
};

export default useTrackViewItem;
